import {Injectable} from "@angular/core";
import {SearchResponse} from "../../objects/responses/searchResponse";
import {UserService} from "../../services/userService";
import {UserSearchRequest} from "../../objects/requests/userSearchRequest";
/**
 * Created by vlad.p on 8/9/2017.
 */

@Injectable()
export class AgentManagementResolver {

    constructor(private userService: UserService) {
    }

    public resolve(): Promise<SearchResponse<Location>> {

        return this.userService.search(new UserSearchRequest({
            Skip: 0,
            Top: 12,
            Query: '',
            FillOrders: true
        })).then(result => {
            return result.Data;
        }).catch(err => {
            return null;
        });
    }

}


// WEBPACK FOOTER //
// ./app/components/agent/agent-management.resolver.ts